<template>
  <main class="employee-profile-page">
    <div class="profile-shell">
      <img
        class="profile-logo"
        src="/assets/img/logo3.png"
        alt="Al Nawadi Holding"
      />

      <section class="business-card">
        <div class="profile-accent"></div>
        <img class="profile-photo" :src="employee.image" :alt="employee.name" />

        <div class="profile-intro">
          <h1>{{ employee.name }}</h1>
          <p>{{ employee.position }}</p>
        </div>

        <h2 class="contact-heading">Contact details</h2>
        <dl class="profile-contact">
          <div>
            <dt><i class="bx bx-mobile-alt"></i> Mobile</dt>
            <dd><a :href="'tel:' + employee.mobile.replace(/\s/g, '')">{{ employee.mobile }}</a></dd>
          </div>
          <div>
            <dt><i class="bx bx-envelope"></i> Email</dt>
            <dd><a :href="'mailto:' + employee.email">{{ employee.email }}</a></dd>
          </div>
          <div>
            <dt><i class="bx bx-phone"></i> Telephone</dt>
              <dd><a :href="'tel:' + employee.telephone.replace(/\s/g, '')">{{ employee.telephone }}</a></dd>
          </div>
          <div>
            <dt><i class="bx bx-hash"></i> Extension</dt>
            <dd>{{ employee.extension }}</dd>
          </div>
          <div>
            <dt><i class="bx bx-globe"></i> Website</dt>
            <dd><a :href="employee.website" target="_blank" rel="noopener">{{ employee.websiteLabel }}</a></dd>
          </div>
          <div>
            <dt><i class="bx bx-map"></i> Address</dt>
            <dd>{{ employee.address }}</dd>
          </div>
        </dl>

        <button type="button" class="save-contact-button" @click="saveContact">
          <i class="bx bx-user-plus"></i> Save contact
        </button>

      </section>
    </div>
  </main>
</template>

<script>
const employee = {
  name: "Mohammed Arsalan",
  position: "Team Leader - Application",
  extension: "165",
  mobile: "+965 66747850",
  email: "mohammed.a@alnawadiholding.com",
  telephone: "+965 22922555",
  website: "https://www.alnawadiholding.com",
  websiteLabel: "alnawadiholding.com",
  address: "Al Hamra Tower, Kuwait City",
  image: "/assets/img/arsalan-passport.jpeg",
  slug: "mohammed-arsalan",
};

export default {
  name: "EmployeeProfile",
  methods: {
    saveContact() {
      const employee = this.employee;
      const escapeVCardValue = (value) => String(value)
        .replace(/\\/g, "\\\\")
        .replace(/;/g, "\\;")
        .replace(/,/g, "\\,")
        .replace(/\n/g, "\\n");
      const vCard = [
        "BEGIN:VCARD",
        "VERSION:3.0",
        `FN:${escapeVCardValue(employee.name)}`,
        `ORG:${escapeVCardValue("Al Nawadi Holding")}`,
        `TITLE:${escapeVCardValue(employee.position)}`,
        `TEL;TYPE=CELL:${escapeVCardValue(employee.mobile)}`,
        `TEL;TYPE=WORK:${escapeVCardValue(employee.telephone)}`,
        `TEL;TYPE=WORK,VOICE:${escapeVCardValue("ext. " + employee.extension)}`,
        `EMAIL;TYPE=INTERNET:${escapeVCardValue(employee.email)}`,
        `URL:${escapeVCardValue(employee.website)}`,
        `ADR;TYPE=WORK:;;${escapeVCardValue(employee.address)};;;;`,
        "END:VCARD",
      ].join("\r\n");
      const blob = new Blob([vCard], { type: "text/vcard;charset=utf-8" });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `${this.$route.params.slug || "employee"}.vcf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 1000);
    },
  },
  computed: {
    employee() {
      return employee;
    },
  },
};
</script>

<style scoped>
.employee-profile-page {
  min-height: 100vh;
  padding: 16px 20px 48px;
  background: #fbf8f3;
  color: #142334;
}

.profile-shell {
  width: 100%;
  max-width: 440px;
  margin: 0 auto;
}

.profile-logo {
  display: block;
  width: 120px;
  height: 99px;
  margin-bottom: 18px;
  margin-left: auto;
  margin-right: auto;
  object-fit: contain;
  text-align: center;
}

.business-card {
  position: relative;
  overflow: hidden;
  padding: 42px 32px 30px;
  border: 1px solid #e2e9ed;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 20px 50px rgba(16, 42, 67, 0.1);
  text-align: center;
}

.profile-accent {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 7px;
  background: #e49a2f;
}

.profile-photo {
  display: block;
  width: 144px;
  height: 144px;
  margin: 0 auto 22px;
  border: 6px solid #fff2d9;
  border-radius: 50%;
  object-fit: cover;
  object-position: center top;
}

.profile-intro h1 {
  margin: 0 0 8px;
  color: #303030;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.profile-intro p {
  margin: 0 0 30px;
  color: #5d7184;
  font-size: 15px;
}

.save-contact-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 24px 0 0;
  padding: 12px 18px;
  border: 0;
  border-radius: 7px;
  background: #e49a2f;
  color: #fff;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  transition: background 0.2s ease, transform 0.2s ease;
}

.save-contact-button i {
  margin-right: 7px;
  font-size: 18px;
}

.save-contact-button:hover {
  background: #d4871e;
  transform: translateY(-1px);
}

.save-contact-button:focus {
  outline: 3px solid rgba(228, 154, 47, 0.3);
  outline-offset: 2px;
}

.profile-contact {
  margin: 0;
  text-align: left;
}

.contact-heading {
  margin: 0 0 4px;
  color: #303030;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-align: left;
  text-transform: uppercase;
}

.profile-contact > div {
  display: grid;
  grid-template-columns: 112px 1fr;
  gap: 10px;
  padding: 13px 0;
  border-top: 1px solid #edf1f3;
}

.profile-contact dt,
.profile-contact dd {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
}

.profile-contact dt {
  color: #738393;
  font-weight: 500;
}

.profile-contact dt i {
  width: 18px;
  color: #c47916;
  font-size: 16px;
  vertical-align: -2px;
}

.profile-contact dd {
  color: #243b53;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.profile-contact a {
  color: #c47916;
  text-decoration: none;
}

.profile-contact a:hover {
  color: #9e5f0d;
}

@media (max-width: 480px) {
  .employee-profile-page {
    padding: 12px 14px 28px;
  }

  .business-card {
    padding: 36px 22px 26px;
  }
}
</style>
